import { render, staticRenderFns } from "./vuex-combo-box.vue?vue&type=template&id=745bf9f6"
import script from "./vuex-combo-box.vue?vue&type=script&lang=js"
export * from "./vuex-combo-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports